/**
 * Caret Down Icon - Downward-pointing arrow for expandable content
 *
 * Design: 16x16 caret pointing down
 * Usage: Read more buttons, dropdown indicators, expandable sections
 * Color: Inherits from parent (uses currentColor)
 */

export const CaretDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.8951 4.13889C15.7551 4.00491 15.5291 4.00395 15.3882 4.13889L8.0195 11.1733L0.611847 4.09965C0.470853 3.96662 0.244864 3.96662 0.10487 4.10061C-0.035123 4.23556 -0.035123 4.45185 0.10587 4.58584L7.72651 11.8614C7.73451 11.8691 7.74751 11.8662 7.75551 11.8729C7.76251 11.8806 7.75951 11.8921 7.76651 11.8988C7.9065 12.0328 8.13349 12.0337 8.27349 11.8988L15.8941 4.62317C16.0351 4.49014 16.0351 4.27288 15.8951 4.13889Z"
      fill="currentColor"
    />
  </svg>
);
